module.exports = __webpack_public_path__ + "img/16d001-12.ef8d1f9c.jpg";